<template>
    <div class="page-container">
        <div class="invoice-item">
            <div class="invoice-status reviewing">审核中</div>
            <div class="invoice-name">北京xxx科技有限公司</div>
            <div class="time-price">
                <span>2020-12-12</span>
                <span>12000元</span>
            </div>
        </div>
        <div class="invoice-item">
            <div class="invoice-status succ">已完成</div>
            <div class="invoice-name">北京xxx科技有限公司</div>
            <div class="time-price">
                <span>2020-12-12</span>
                <span>12000元</span>
            </div>
        </div>
        <div class="invoice-item">
            <div class="invoice-status failed">审核失败</div>
            <div class="invoice-name">北京xxx科技有限公司</div>
            <div class="time-price">
                <span>2020-12-12</span>
                <span>12000元</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    
}
</script>
<style lang="scss" scoped>
@mixin flex-between{
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.page-container{
    min-height:calc(100vh - 46px);
    background:#fafafa;
    box-sizing: border-box;
    padding:10px;
    .invoice-item{
        padding:15px 20px;
        background: #fff;
        margin-bottom: 10px;
        position: relative;
        overflow: hidden;
        @media screen and (max-width: 750px){
            border-radius: 4px;
        }
        .invoice-status{
            width:75px;
            height:29px;
            text-align: center;
            line-height: 29px;
            position: absolute;
            top:0;
            right:0;
            font-size: 14px;
            color:#fff;
            @media screen and (max-width: 750px){
                border-bottom-left-radius: 15px;
            }
            &.reviewing{
                background:#FFA11F;
            }
            &.succ{
                background: #C8C8C8;
            }
            &.failed{
                background: #FA464A;
            }
        }
        .invoice-name{
            color:#333;
            font-size: 14px;
            line-height: 20px;
            margin-bottom: 10px;
        }
        .time-price{
            @include flex-between;
            &>span{
                font-size: 14px;
                color:#999;
                line-height: 20px;
                &:last-child{
                    color:#3088F5;
                }
            }
        }
    }
}
</style>